// Module
var code = "<template> <require from=\"app/cm/admin/system-illness/system-illness\"></require> <system-illness></system-illness> </template> ";
// Exports
module.exports = code;